/**
 * API-клиент для дневной статистики одного Instagram аккаунта.
 */

import { getAuthHeaders } from './auth-headers';
import { SUPABASE_FUNCTIONS_URL } from './config';

export type DayDataPoint = {
  date: string;
  impressions: number | null;
  reach: number | null;
  interactions: number | null;
  follower_delta: number | null;
};

export type AccountDailyInsightsResponse = {
  days: DayDataPoint[];
  username: string;
  name: string | null;
  avatar_url: string | null;
  totals: {
    impressions: number | null;
    reach: number | null;
    interactions: number | null;
    follower_delta: number | null;
  };
};

export async function fetchAccountDailyInsights(params: {
  accountId: string;
  since: number;
  until: number;
}): Promise<AccountDailyInsightsResponse> {
  const headers = await getAuthHeaders();

  const response = await fetch(`${SUPABASE_FUNCTIONS_URL}/instagram/account-insights-daily`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      account_id: params.accountId,
      since: params.since,
      until: params.until,
    }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || `Ошибка сервера: ${response.status}`);
  }

  return response.json();
}
